import { useCallback } from 'react'
import { router } from '@inertiajs/react'
import { toast } from 'sonner'
import { useInboxChannel } from '@/hooks/useInboxChannel'
import type { ConversationListItem } from '@/components/inbox/types'
import { playNotificationSound } from '@/lib/notificationSound'
import { stripHtml } from '@/lib/sanitizeHtml'

interface UseGlobalInboxNotificationsProps {
  enabled: boolean
  currentAgentId: number
  currentAgentTeamIds: number[]
}

export function useGlobalInboxNotifications({ enabled, currentAgentId, currentAgentTeamIds }: UseGlobalInboxNotificationsProps) {
  const handleConversationUpdated = useCallback(
    (conversation: ConversationListItem) => {
      if (!conversation.has_new_end_user_message) return

      // Only notify if the conversation is relevant to this agent
      const isAssignedToMe = conversation.assigned_agent?.id === currentAgentId
      const isAssignedToOther = conversation.assigned_agent && conversation.assigned_agent.id !== currentAgentId
      const isInMyTeam = conversation.team_id && currentAgentTeamIds.includes(conversation.team_id)
      const hasNoTeam = !conversation.team_id

      const isRelevant =
        isAssignedToMe ||
        (!isAssignedToOther && (isInMyTeam || hasNoTeam))

      if (!isRelevant) return

      playNotificationSound()

      const userName = conversation.end_user?.name || 'Visitante'
      const preview = conversation.last_message
        ? stripHtml(conversation.last_message).slice(0, 80)
        : ''

      toast(userName, {
        description: preview || 'Nova mensagem recebida',
        action: {
          label: 'Ver conversa',
          onClick: () => router.visit(`/inbox/${conversation.id}`),
        },
        duration: 5000,
      })
    },
    []
  )

  useInboxChannel({
    onConversationUpdated: handleConversationUpdated,
    enabled,
  })
}
